import { render, staticRenderFns } from "./WorkDescription.vue?vue&type=template&id=6be41c20&scoped=true&"
import script from "./WorkDescription.vue?vue&type=script&lang=js&"
export * from "./WorkDescription.vue?vue&type=script&lang=js&"
import style0 from "./WorkDescription.vue?vue&type=style&index=0&id=6be41c20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be41c20",
  null
  
)

export default component.exports